import { useAuth } from "../context/AuthContext";
import SiteNav from "../components/SiteNav";
import SiteFooter from "../components/SiteFooter";
import Seo from "../components/Seo";
import { PricingSection } from "../components/PricingSection";
import { Hero } from "../components/landing/Hero";
import { StatsBar } from "../components/landing/StatsBar";
import { FeaturesSection, HowItWorks } from "../components/landing/FeaturesSection";
import { FounderSection, FaqSection, GuidesTeaser, CtaBanner } from "../components/landing/SocialSections";
import { TestimonialsSection } from "../components/landing/Testimonials";
import { MobileCtaBar } from "../components/landing/MobileCtaBar";
import { FAQ } from "../data/landing";

const SOFTWARE_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Fast Estimate",
  url: "https://getfastestimate.com",
  logo: "https://getfastestimate.com/icon-192.png",
  description: "AI-powered HVAC estimating software for contractors — $99.99/month flat rate, 7-day free trial.",
  slogan: "Photo to signed HVAC estimate in two minutes",
  founder: { "@type": "Person", name: "Scott Herberg", description: "HVAC contractor, 28 years in the trade" },
  email: "info@herbergllc.com",
  address: { "@type": "PostalAddress", streetAddress: "30 Gould St Suite R", addressLocality: "Sheridan", addressRegion: "WY", postalCode: "82801", addressCountry: "US" },
  areaServed: [{ "@type": "Country", name: "United States" }, { "@type": "Country", name: "Canada" }],
  makesOffer: {
    "@type": "Offer", name: "Fast Estimate Pro — flat monthly plan", price: "99.99", priceCurrency: "USD",
    description: "Unlimited estimates and unlimited technician seats for the whole company. 7-day free trial, no credit card required.",
    url: "https://getfastestimate.com/pricing",
  },
};

const WEBSITE_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Fast Estimate",
  url: "https://getfastestimate.com",
  description: "AI HVAC estimating software for contractors in the US and Canada.",
  publisher: { "@type": "Organization", name: "Fast Estimate", url: "https://getfastestimate.com" },
};
const FAQ_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQ.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};
const LANDING_JSONLD = [SOFTWARE_SCHEMA, WEBSITE_SCHEMA, FAQ_SCHEMA];

export default function Landing() {
  const { user } = useAuth();

  return (
    <div className="bg-white">
      <Seo
        title="Fast Estimate — AI HVAC Estimating Software"
        description="Snap a photo of the unit and get a branded, line-itemized HVAC estimate with e-signature in under two minutes. 7-day free trial, no credit card."
        path="/"
        jsonLd={LANDING_JSONLD}
      />
      <SiteNav />
      <Hero />
      <StatsBar />
      <FeaturesSection />
      <HowItWorks />
      <TestimonialsSection />
      <PricingSection user={user} />
      <FounderSection />
      <FaqSection />
      <GuidesTeaser />
      <CtaBanner />
      <SiteFooter />
      <div className="h-20 md:hidden" aria-hidden="true" />
      <MobileCtaBar />
    </div>
  );
}
